module.exports = __webpack_public_path__ + "static/media/matt.5084fdb5.jpg";